export const validatePhoneNumber = (phone: string): boolean => {
  const phoneRegex = /^010-\d{3,4}-\d{4}$/;
  return phoneRegex.test(phone);
};
